/** * チェックインカードコンポーネント */
<template>
  <div class="card-checkin-detail">
    <!-- ユーザー -->
    <card-user
      can-user-name-click
      v-bind:user-id="userId"
      v-bind:user-name="userName"
      v-bind:profile-image-attach-file-type="profileImageAttachFileType"
      v-bind:groups="groups"
      v-on:usercard-username-click="
        $store.dispatch('updateProfileUserId', $event)
      "
    />
    <b-card-text
      align="left"
      v-on:click="$_onClickCard"
      class="card-checkin-detail-body"
    >
      <div
        class="card-checkin-detail-body-checkin"
        v-bind:style="{
          paddingBottom: checkoutAt ? 'calc(10px - 6px)' : 'calc(20px - 6px)',
        }"
      >
        <!-- チェックインタイトル -->
        <div class="card-checkin-detail-title">
          <icon-checkin class="icon-checkin" />
          <p>
            <span v-on:click="$_onClickTitle">
              {{ placeName }}
            </span>
          </p>
        </div>
        <div class="update-at-text">{{ checkinUpdateAt }}</div>
        <!-- チェックインデータリスト -->
        <data-list v-bind:data="checkinDataList" />
      </div>

      <div v-if="checkoutAt" class="card-checkin-detail-body-checkout">
        <!-- チェックアウトデータリスト -->
        <data-list v-bind:data="checkoutDataList" />
      </div>
    </b-card-text>
  </div>
</template>

<script>
import CardUser from '@/components/AppCardUser.vue'
import IconCheckin from '@/assets/ifield/ic_checkin.svg?component'
import DataList from '@/components/AppDataList.vue'
import { useDateDisplayText } from '@/composables/UseDateDisplayText'
import { toRefs } from 'vue'

// タイムラインタイプ
const TIMELINE_TYPE = 4
// AppDataListに設定するデータタイプ
const DATA_LIST_TYPE = {
  /** 日時 */
  DATE_TIME: 5,
}
export default {
  name: 'AppCardCheckinDetail',
  components: {
    'card-user': CardUser,
    'icon-checkin': IconCheckin,
    'data-list': DataList,
  },
  props: {
    // タイムラインID、チェックインID(一意となるIDを設定する)
    id: {
      type: Number,
      required: true,
    },
    // ユーザID
    userId: {
      type: Number,
      required: true,
    },
    // チェックイン日時
    checkinAt: {
      type: String,
      required: true,
    },
    // チェックインコメント
    checkinComment: {
      type: String,
      default: null,
    },
    // チェックアウト日時
    checkoutAt: {
      type: String,
      default: null,
    },
    // チェックアウトコメント
    checkoutComment: {
      type: String,
      default: null,
    },
    // プレイス名
    placeName: {
      type: String,
      required: true,
    },
    // 送信者プロフィール画像の添付ファイルタイプ
    profileImageAttachFileType: {
      type: String,
      required: false,
    },
    // 送信ユーザ名
    userName: {
      type: String,
      required: true,
    },
    // 更新日時
    updateAt: {
      type: String,
      default: null,
    },
    /**
     * 基準日時
     */
    baseDate: {
      type: Date,
      default: null,
    },
    /**
     * 所属グループ
     */
    groups: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    // 更新日時の表示テキスト
    const { updateAt, baseDate } = toRefs(props)
    const { text } = useDateDisplayText({ date: updateAt, baseDate })
    return { checkinUpdateAt: text }
  },
  computed: {
    /**
     * チェックインDataListコンポーネントに設定するデータ
     * @type {Array.<Object>}
     */
    checkinDataList: function () {
      const dataList = {
        standard: [
          {
            label: this.$t('appCardCheckinDetail.checkinDate'),
            type: DATA_LIST_TYPE.DATE_TIME,
            value: this.checkinAt,
          },
        ],
      }
      if (this.checkinComment) {
        dataList.standard.push({
          label: this.$t('appCardCheckinDetail.comment'),
          value: this.checkinComment,
        })
      }

      return dataList
    },
    /**
     * チェックアウトDataListコンポーネントに設定するデータ
     * @type {Array.<Object>}
     */
    checkoutDataList: function () {
      const dataList = {
        standard: [
          {
            label: this.$t('appCardCheckinDetail.checkoutDate'),
            type: DATA_LIST_TYPE.DATE_TIME,
            value: this.checkoutAt,
          },
        ],
      }
      if (this.checkoutComment) {
        dataList.standard.push({
          label: this.$t('appCardCheckinDetail.comment'),
          value: this.checkoutComment,
        })
      }

      return dataList
    },
  },
  methods: {
    /**
     * クリック時のイベント
     */
    $_onClickCard: function () {
      this.$emit('checkincard-click', TIMELINE_TYPE, this.id)
    },
    /**
     * タイトルクリック時のイベント
     */
    $_onClickTitle: function (event) {
      event.stopPropagation()
      this.$emit('checkincard-title-click', TIMELINE_TYPE, this.id)
    },
  },
}
</script>

<style lang="scss" scoped>
.card-checkin-detail {
  min-height: 184px;
  display: grid;
  grid-template-rows: max-content 1fr;
  row-gap: 10px;
}

::v-deep .card-user {
  padding-right: 8px;
}

.card-checkin-detail-body {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 0;
  background-color: #f6f6f6;
  border-radius: 2px;
  overflow: hidden;
  transition: 0.2s;
  cursor: pointer;

  &:hover {
    background-color: #f0f0f0;
  }
}

.card-checkin-detail-body-checkin {
  width: 100%;
  height: 100%;
  padding: 24px 20px 20px 20px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  .card-checkin-detail-title {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    p {
      margin-bottom: 0;
      line-height: 20px;
      color: #4d4d4d;
      font-size: 0.9em !important;
    }

    span {
      color: $text-color-link;
      font-weight: bold;
      margin-right: 4px;

      &:hover {
        text-decoration: underline;
      }
    }
  }
  .update-at-text {
    font-size: $font-size-small;
    color: #959595;
    margin: 8px 0 16px 0;
  }
}

.card-checkin-detail-body-checkout {
  width: 100%;
  height: auto;
  background-color: #eeeeee;
  padding: 10px 20px calc(10px - 6px) 20px;
}

.icon-checkin {
  height: 20px;
  width: 20px;
  padding: 3px;
  margin-right: 12px;
  border-radius: 50%;
  position: relative;
  fill: #654928;
  background-color: $entity-color-yellow;
  flex-shrink: 0;
}

::v-deep .data-title {
  width: 110px !important;
}

::v-deep .list-wrapper {
  margin: 0 !important;
}

::v-deep .data-list {
  height: auto !important;
}

::v-deep .data-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
